import { ReferralType } from '@wix/da-shared-react/pkg/biLogger';
import { ModuleType } from '../../../../types/modules';

export const moduleTypeToReferralType = (moduleType: ModuleType | null) => {
  switch (moduleType) {
    case ModuleType.CUSTOM:
      return ReferralType.CUSTOM_BOX;
    case ModuleType.STATS:
      return ReferralType.USER_STATS;
    default:
      return undefined;
  }
};
